exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-47159f04],.fade-leave-active[data-v-47159f04]{-webkit-transition:opacity .25s;transition:opacity .25s}.fade-enter[data-v-47159f04],.fade-leave-to[data-v-47159f04]{opacity:0}", ""]);

// exports
